/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_Error_LoginInputs */



/**
* | output |
* | --- |
* | "Passkey login failed." |
*
* @param {Passkey_Error_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const passkey_error_login = /** @type {((inputs?: Passkey_Error_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_Error_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion avec Passkey a échoué.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El inicio de sesión con Passkey ha fallado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Login com Passkey falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso con Passkey fallito.")
	return /** @type {LocalizedString} */ ("Passkey login failed.")
});